class FP_Docs {
	constructor() {
		this.init();
	}

	init() {
		this.linkHeadings();

		document.addEventListener('click', function(e) {
			this.handleSurveyFeedback(e);

			this.handleMobileToc(e);
			this.handleMobileSidebarCategoriesToggle(e);
		}.bind(this));
	}

	/**
	 * Handles Yes/No processing on docs surveys
	 * 
	 * @param   {Event}   e 
	 * 
	 * @return  void
	 */
	handleSurveyFeedback(e) {
		let btn = e.target.closest('.docs-survey-btn');
		if (!btn) {
			return false;
		}

		e.preventDefault();

		const wrapper = btn.closest('.docs-survey');

		const data = new FormData();
		data.append('value', btn.dataset.value);
		data.append('item_id', btn.dataset.itemId);
		data.append('nonce', wrapper.querySelector('input[type="hidden"][name="nonce"]').value);
		data.append('action', 'fp_docs_ajax_survey');

		wrapper.classList.add('running');

		fetch(fireplugins.ajax_url, {
			method: 'POST',
			body: data
		})
		.then(function(response) {
			return response.json();
		})
		.then((resp) => {
			wrapper.classList.remove('running');

			// show message
			wrapper.querySelector('.message').innerHTML = resp.response;
			wrapper.querySelector('.message').classList.remove('hide');

			// hide form
			wrapper.querySelector('.form').remove();
		});
	}

	/**
	 * Shows/hides the sidebar containing the categories on mobile devices
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	handleMobileToc(e) {
		let btn = e.target.closest('.fp-docs-mobile-toc-toggle');
		if (!btn) {
			return false;
		}

		btn.previousElementSibling.classList.toggle('open');

		e.preventDefault();
	}

	/**
	 * Shows/hides the sidebar containing the categories on mobile devices
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	handleMobileSidebarCategoriesToggle(e) {
		if (!e.target.closest('.docs-mobile-categories-toggle')) {
			return false;
		}

		document.querySelector('.fp-docs-categories-tree-list').classList.toggle('open');
	}

	/**
	 * Link all h2, h3 and h4 headings in docs.
	 * 
	 * @return  void
	 */
	linkHeadings() {
		var headings = document.querySelectorAll('.fp-docs-single h2[id]');

		if (!headings.length) {
			return;
		}

		headings.forEach(function(el) {
			if (!el.classList.contains('scroll-to')) {
				var e = document.createElement('a');
				e.href = '#' + el.id;
				e.className = 'dashicons dashicons-admin-links';
				el.classList.add('scroll-to', 'fixed-position');
				el.insertBefore(e, el.firstChild);
			}
		});
	}
}

FP_Utils.onReady(function() {
	new FP_Docs();
});